import React from "react";
const IntroductionComponent = () => {
  return (
    <>
      <p className="title">minera（ミネラ）とは</p>
      <p>社会人や大学生同士で仕事やトレーニングの興味や悩みを</p>
      <p>タイムラインやビデオ通話やメッセージで伝えて、</p>
      <p>日々のモチベーションをサポートするアプリです</p>
    </>
  );
};
export default IntroductionComponent;